import { colors } from './colors';

export const fonts = {
  telka: 'Telka, sans-serif',
  telkaExtended: 'Telka Extended, sans-serif',
} as const;

export const styledTheme = {
  mainColors: colors,
  fonts,
} as const;
